import { Component, ReactNode } from 'react';
import api from '../../common/api';
import { useSelector } from 'react-redux';

import { selectUserProfile } from '../../features/auth/ducks';
import { UserProfile } from '../../common/models/User';
import { Utils } from '../../common/components';

interface State {
  hasError: boolean;
}

interface ErrorBoundaryInnerProps {
  children: ReactNode;
  profile: UserProfile | null;
}

class ErrorBoundaryInner extends Component<ErrorBoundaryInnerProps, State> {
  state = {
    hasError: false,
  };

  componentDidCatch(e: Error) {
    if (process.env.NODE_ENV !== 'development') {
      api.journal.postError(e, {
        userId: this.props.profile?.id ?? 'Unknown',
      });
    }
    this.setState({ hasError: true });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    return hasError ? <Utils.Error /> : children;
  }
}

export default function ErrorBoundary({ children }: { children: ReactNode }) {
  const profile = useSelector(selectUserProfile);
  return <ErrorBoundaryInner profile={profile}>{children}</ErrorBoundaryInner>;
}
